/** A company's public Careers Page, as routed in App.tsx (`/:companySlug/careers`). */
export const careersPageUrl = (origin: string, careersPageSlug: string) =>
  `${origin}/${careersPageSlug}/careers`;
